import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  styleUrls: ['./custom-tooltip.component.scss'],
  templateUrl: './custom-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomTooltipComponent {
  @Input() imageUrl = '';

  public imageLoaded = false;

  public loaded(): void {
    this.imageLoaded = true;
  }
}
